import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setName
} from '../redux/layoutGroups'

export default function * requestRenameLayoutGroup (action) {
  const { layoutId, id, name } = action.payload

  const optimisticAction = yield optimisticPut(setName({
    key: `${layoutId}-${id}`,
    name
  }))

  try {
    yield call(apiAction, 'RenameLayoutGroup', {
      layoutId,
      groupId: id,
      name
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()
  }
}
